export const getVariantFromLocale = (locale) => locale.toLowerCase();